import mapKnownValues from "@/utils/mapKnownValues";

export enum RoleEnum {
  All = "all",
  User = "User",
  Admin = "Admin",
  Property = "Property",
  Organization = "Organization",
  AdminReadOnly = "AdminReadOnly",
  NoAccess = "NoAccess",
  Support = "Support"
}

export type RoleAPIResponse = {
  id: string;
  rName: Exclude<keyof typeof RoleEnum, "All">;
  rKey: string;
};

export default class Role {
  id = "";
  rName: RoleEnum = RoleEnum.NoAccess;
  rKey = "";

  constructor(params: Partial<Role>) {
    mapKnownValues(this, params);
  }

  static fromAPI(response: RoleAPIResponse) {
    return new Role({
      ...response,
      rName: response.rName as RoleEnum
    });
  }
}
